// src/utils/analytics.ts
// Google Analytics 4 custom event tracking
// Window.gtag type declared in react-app-env.d.ts

const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

// Core actions
export const trackCodeExecuted = (language: string, success: boolean) =>
  trackEvent('code_executed', { language, success });

export const trackChatMessageSent = (intent?: string) =>
  trackEvent('chat_message_sent', { intent: intent || 'unknown' });

export const trackBookmateGenerated = (topic: string) =>
  trackEvent('bookmate_generated', { topic: topic.substring(0, 100) });

export const trackWorkflowStarted = (prompt: string) =>
  trackEvent('workflow_started', { prompt: prompt.substring(0, 100) });

export const trackSubscriptionUpgraded = (tier: string, gateway: string) =>
  trackEvent('subscription_upgraded', { tier, gateway });

export const trackCreditPackPurchased = (quantity: number, amount: number) =>
  trackEvent('credit_pack_purchased', { quantity, amount });

// Engagement
export const trackProBannerDismissed = () =>
  trackEvent('pro_banner_dismissed');

export const trackProBannerClicked = () =>
  trackEvent('pro_banner_clicked');

export const trackSessionSwitched = () =>
  trackEvent('session_switched');

export const trackThemeToggled = (theme: string) =>
  trackEvent('theme_toggled', { theme });
